import React from "react";
import { connect } from "react-redux";
import { withTheme } from "styled-components";
import BookSwimlane from "../../bookviews/book-swimlane";
import BridgeBook from "../../book/bridge-book";
import FetchingSpinner from "../../../../components/spinner/render-prop-spinner";
import {
  actions as bridgeActions,
  selectors as bridgeSelectors
} from "../../../../../redux/bridge";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import {
  brandedSubscriptionCategoryParams,
  formatBrandedSubscriptionCategoryParams
} from "../../../../../redux/bridge/utils";

class SubscriptionCategoryLanes extends React.Component {
  componentDidMount() {
    const { fetchLists, lanes, subscriptionVbid } = this.props;
    fetchLists(brandedSubscriptionCategoryParams(lanes, subscriptionVbid));
  }

  render() {
    const {
      lanes,
      assetsBySubscription,
      loadingBySubscription,
      expandSwimlane
    } = this.props;
    return (
      <div>
        {lanes &&
          lanes.map(lane => {
            const assets = assetsBySubscription && assetsBySubscription[lane];
            return (
              <FetchingSpinner
                key={`spinner-${lane}`}
                loading={loadingBySubscription[lane]}
                component={() => {
                  return (
                    assets && (
                      <BookSwimlane
                        key={`swimlane-${lane}`}
                        isbns={assets.map(asset => asset.vbid)}
                        BookObject={BridgeBook}
                        headerLabel={lane}
                        onHeaderClick={() => expandSwimlane(assets, lane)}
                        count={assets.length}
                      />
                    )
                  );
                }}
              />
            );
          })}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const assets = {};
  const loading = {};
  props.lanes.map(lane => {
    const params = formatBrandedSubscriptionCategoryParams(
      lane,
      props.subscriptionVbid
    );
    assets[lane] = bridgeSelectors.getAssets(state, params);
    loading[lane] = bridgeSelectors.isAssetsFetching(state, params);
  });
  return {
    assetsBySubscription: assets,
    loadingBySubscription: loading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists))
});

export default withAllMatches(
  withTheme(
    connect(mapStateToProps, mapDispatchToProps)(SubscriptionCategoryLanes)
  )
);
